export default {
  empty_list: 'Nicio categorie încă',
  uses_restaurant_open_times: 'Folosește orele de deschidere ale restaurantului',
  products_creation_disabled:
    'Din cauza integrării active cu {{integration}}, crearea de produse noi nu este permisă. Dacă doriți să modificați meniul, faceți modificările în {{integration}} și sincronizați meniul.',
  buttons: {
    add_category: 'Adaugă categorie',
  },
  toasts: {
    something_went_wrong: 'Ceva a mers greșit',
  },
};
